import apiService from "./apiService";
import { PRODUCT_ENDPOINTS } from "./endpoints/productEndpoints";
import { placeOrder as placeOrderRpc } from "./postgre/orderApi";
import { getCategories as rpcGetCategories, getProductListPaged } from "./postgre/productApi";

export const getProductList = async () => getProductListPaged();

export { getProductListPaged };

export const getCategories = async () => rpcGetCategories();

export const placeOrder = async (payload) => placeOrderRpc(payload);

export const getDefaultImage = async () => {
    const response = await apiService.get(PRODUCT_ENDPOINTS.DEFAULT_IMAGE);
    return response?.data;
};
